import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.75 3C3.75 2.58579 3.41421 2.25 3 2.25C2.58579 2.25 2.25 2.58579 2.25 3V21C2.25 21.4142 2.58579 21.75 3 21.75H21C21.4142 21.75 21.75 21.4142 21.75 21C21.75 20.5858 21.4142 20.25 21 20.25H3.75V3Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 13.4651V17.6129C6 17.8801 6.21664 18.0967 6.48387 18.0967H20.5C20.7761 18.0967 21 17.8729 21 17.5967V7.20706C21 6.7616 20.4614 6.53852 20.1464 6.8535L15.5471 11.4528C15.3518 11.6481 15.0353 11.6481 14.84 11.4528L11.6761 8.28899C11.4809 8.09373 11.1643 8.09372 10.969 8.28899L6.14645 13.1116C6.05268 13.2053 6 13.3325 6 13.4651Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export { SvgIconArea as ReactComponent };
